import { createSelector } from 'reselect';

const selectTaxSettings = (state: any) => state.taxSettings;


export const selectCurrentItem = createSelector([selectTaxSettings], (taxSettings) => taxSettings.current);

export const selectListItems = createSelector([selectTaxSettings], (taxSettings) => taxSettings.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectCreatedItem = createSelector([selectTaxSettings], (taxSettings) => taxSettings.create);

export const selectUpdatedItem = createSelector([selectTaxSettings], (taxSettings) => taxSettings.update);

export const selectReadItem = createSelector([selectTaxSettings], (taxSettings) => taxSettings.read);

export const selectDeletedItem = createSelector([selectTaxSettings], (taxSettings) => taxSettings.delete);

export const selectSearchedItems = createSelector([selectTaxSettings], (taxSettings) => taxSettings.search);

export const selectItemsCount = createSelector([selectTaxSettings], (taxSettings) => taxSettings.count);

export const selectItemsFilter = createSelector([selectTaxSettings], (taxSettings) => taxSettings.filter);